import { Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FocoService } from 'src/app/api/services/foco.service';
import { Product } from 'src/app/api/models/product';
import { FocoItem } from 'src/app/api/models/foco';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-foco-modal',
    templateUrl: 'foco-dialog.component.html',
    styleUrls: ['foco-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FocoDialogComponent {
  searchTerm: string = '';
  alternativeSearchTerm: string = '';
  products: Product[] = [];
  alternativeProducts: Product[] = [];
  selectedProduct: Product | null = null;
  selectedProductName: string = '';
  objetivo: string = '';
  focoInt: number | null = null;
  isEditing = false;
  selectedAnf: string;
  selectedMonth: Date;
  productNotFound: boolean = false;
  alternativesNotFound: boolean = false;
  isPortfolio: boolean = true;
  isInputValid = false;

  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;

  constructor(
    private dialogRef: MatDialogRef<FocoDialogComponent>,
    private focoService: FocoService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: { selectedAnf: string; selectedMonth: Date } // change type here
  ) {
    this.selectedAnf = data.selectedAnf;
    this.selectedMonth = data.selectedMonth; // add this line
  }

  postFoco() {
    if (this.selectedProduct && this.focoInt) {
      const newFocoItem: FocoItem = {
        focoInt: this.focoInt,
        produto: {
          cod_produto: this.selectedProduct.codigoProduto,
          nome: this.selectedProduct.nome,
        },
      };

      const { ...payload } = newFocoItem;
/*       console.log(payload);
      console.log(this.selectedAnf, this.selectedMonth); */
      this.focoService
        .postFocoItem(payload, this.selectedAnf, this.selectedMonth)
        .subscribe({
          next: (createdProduct) => {
            // Handle success
            this.snackBar.open('Foco criado com sucesso.', 'Close', {
              duration: 2000,
            });

            // Close the dialog and pass the created product as a result
            this.dialogRef.close(createdProduct);
          },
          error: (error) => {
            // Handle error
            this.snackBar.open(
              'Erro ao criar o foco: ' + error.message,
              'Close',
              {
                duration: 3000,
              }
            );
          },
          complete: () => {
            // Handle completion
          },
        });
    }
  }

  searchProducts() {
    if (this.searchTerm.length < 3) {
      this.snackBar.open(
        'Por favor insira pelo menos 3 caracteres para pesquisar produtos.',
        'Fechar',
        {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
        }
      );
      return;
    }
    this.alternativeSearchTerm = '';

    const sortBy = 'Nome';
    const sortDirection = 'asc';
    const skip = '0';
    const take = '100';

    this.focoService
      .getProducts(this.searchTerm, sortBy, sortDirection, skip, take)
      .subscribe((result) => {
        this.products = result.products;
        this.productNotFound = this.products.length === 0;
        this.autocomplete.openPanel();
      });
  }

  searchAlternativeProducts() {
    const sortBy = 'MargemBruta';
    const sortDirection = 'desc';
    const skip = '0';
    const take = '100';

    this.focoService
      .getPortfolioAlternatives(
        this.alternativeSearchTerm,
        sortBy,
        sortDirection,
        skip,
        take
      )
      .subscribe((result) => {
        this.alternativeProducts = result.products;
        this.alternativesNotFound = this.alternativeProducts.length === 0;
      });
  }

  selectProduct(product: Product) {
    this.selectedProduct = product;
    this.searchTerm = product.nome.toUpperCase();
    this.isPortfolio = product.flag_Portfolio;
    // console.log("Is portfolio? ", this.isPortfolio);

    if (!this.isPortfolio) {
      this.alternativeSearchTerm = '';
      this.alternativeProducts = [];
      this.alternativesNotFound = true;
      if (
        product.cnpem &&
        product.cnpem.trim() !== '' &&
        product.cnpem !== '' &&
        product.cnpem !== '0' &&
        product.cnpem !== null
      ) {
        this.alternativeSearchTerm = product.cnpem;
        this.searchAlternativeProducts();
        this.alternativeProducts = [];
      } else if (
        product.hmR_HMR3 &&
        product.hmR_HMR3.trim() !== '' &&
        product.hmR_HMR3 !== '' &&
        product.hmR_HMR3 !== '0' &&
        product.hmR_HMR3 !== null &&
        product.hmR_HMR3 !== 'H99.1.1. - MSRM'
      ) {
        this.alternativeSearchTerm = product.hmR_HMR3;
        this.searchAlternativeProducts();
        this.alternativeProducts = [];
      }
    }
  }

  updateSearchTerm(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchTerm = target ? target.value : '';
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  clearInput() {
    this.searchTerm = '';
    this.selectedProduct = null;
    this.products = [];
    this.productNotFound = false;
    this.alternativeSearchTerm = '';
    this.alternativeProducts = [];
    this.alternativesNotFound = true;
  }

  numericOnly(event: KeyboardEvent): void {
    const charCode = event.key;
    if (!charCode.match(/[0-9]/)) {
      event.preventDefault();
    }
  }
}
